import { graphql } from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import environment from "../../Environment";

import {
  UpdatePosition_Mutation,
  type PositionLevel,
} from "./__generated__/UpdatePosition_Mutation.graphql";

const mutation = graphql`
  mutation UpdatePosition_Mutation($input: PositionUpdateInput!) {
    updatePosition(input: $input) {
      position {
        ...PositionsPage_position @relay(mask: false)
      }
    }
  }
`;

type InputType = {
  positionId: string;
  description?: string;
  level?: PositionLevel | null;
};

export default ({ positionId, level, description }: InputType, config?: { onCompleted?: () => void }) => {
  const variables = {
    input: {
      position: {
        id: positionId,
        level,
        description
      },
    },
  };

  commitMutation<UpdatePosition_Mutation>(environment, {
    mutation,
    variables,
    onCompleted: config?.onCompleted,
  });
};
